import {
  Datagrid,
  FunctionField,
  List,
  SelectInput,
  TextField,
  TextInput,
  useRecordContext,
} from 'react-admin';
import { Avatar } from '@mui/material';
import { SuspendUserButton } from './UserActions';
import { StatusChip } from '../../components/StatusChip';
import { formatDate, formatDateTime, userStatusLabels } from '../../i18n/labels';

const usersFilters = [
  <TextInput key="search" source="search" label="Поиск (телефон/email/имя)" alwaysOn />,
  <SelectInput
    key="status"
    source="status"
    label="Статус"
    choices={[
      { id: 'active', name: 'Активный' },
      { id: 'suspended', name: 'Заблокирован' },
      { id: 'deleted', name: 'Удалён' },
      { id: 'all', name: 'Все' },
    ]}
    alwaysOn
  />,
];

function AvatarField(): JSX.Element {
  const record = useRecordContext<{
    avatarUrl: string | null;
    displayName: string | null;
  }>();
  if (!record) return <span />;
  return (
    <Avatar
      src={record.avatarUrl ?? undefined}
      sx={{ width: 32, height: 32 }}
      alt={record.displayName ?? ''}
    />
  );
}

export function UsersList(): JSX.Element {
  return (
    <List
      filters={usersFilters}
      filterDefaultValues={{ status: 'active' }}
      perPage={50}
      pagination={false}
    >
      <Datagrid bulkActionButtons={false} rowClick="show">
        <AvatarField />
        <TextField source="displayName" label="Имя" />
        <TextField source="phone" label="Телефон" />
        <TextField source="email" label="Email" />
        <FunctionField
          label="Статус"
          render={(record: { status: string }) => (
            <StatusChip status={record.status} dict={userStatusLabels} />
          )}
        />
        <TextField source="rating" label="Рейтинг" />
        <FunctionField
          label="Дата рожд."
          render={(record: { birthDate: string | null }) => formatDate(record.birthDate)}
        />
        <FunctionField
          label="Зарег."
          render={(record: { createdAt: string }) => formatDateTime(record.createdAt)}
        />
        <SuspendUserButton />
      </Datagrid>
    </List>
  );
}
